import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    height: 220,
    width: 430,
    margin: 15,
    padding: 20
  }
}));

export default function SkeletonLaboratoryCard() {
  const classes = useStyles();
  return (
    <Skeleton className={classes.root} variant="rect" />
  );
}